import {mostrarMensajeDeErrorConToast, responseCode200} from "../../consumers/httpRequiestsUtils";
import {toast} from "react-toastify";
import {usePutRequest} from "../usePutRequest/usePutRequest";

export const useManagePutRequest = () => {
    const [executePutRequest] = usePutRequest();

    const managePutRequest = async (api, payload, callbackSuccess, showToastSuccess = false, callbackFailure = null, showToastError = true) => {
        const response = await executePutRequest(api, payload);
        if (responseCode200(response)) {
            if (showToastSuccess) {
                const msg = response?.data?.message || response?.data?.Message || 'Actualización realizada correctamente';
                const opts = { autoClose: 5000,
                    onOpen: () => console.log('%c[Toast OPEN] PUT success | api:', 'color:#2ecc71;font-weight:bold', api, '| msg:', msg, '| autoClose: 5000ms'),
                    onClose: () => console.log('%c[Toast CLOSE] PUT success | api:', 'color:#e74c3c;font-weight:bold', api)
                };
                toast.success(msg, opts);
            }
            if (typeof callbackSuccess === 'function') {
                callbackSuccess(response);
            }
        } else {
            if(showToastError) mostrarMensajeDeErrorConToast(response);
            if(callbackFailure && typeof callbackFailure === 'function') {
                callbackFailure(response);
            }
        }
        return response;
    };

    return [managePutRequest]
};